const store = (state = null, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'SET_LIVE_STREAM':
      return payload;

    case 'UPDATE_LIVE_STREAM':
      if (payload._id !== state?._id) return state;

      return { ...state, ...payload };

    case 'NEW_LIVE_STREAM_MESSAGE':
      if (payload.roomId !== state?._id) return state;

      return {
        ...state,
        messages: [
          payload.comment,
          ...(state.messages || []).filter((x, i) => x._id !== payload.comment._id)
        ]
      };

    case 'LOGOUT':
      return null;

    case 'RESET_LIVE_STREAM_STATE':
      return null;

    default:
      return state;
  }
};

export default store;
